const newFormData = {
  display: 'form',
  components: [
    {
      label: 'Header',
      tableView: false,
      key: 'header',
      type: 'container',
      input: true,
      components: [
        {
          label: 'header',
          key: 'header',
          type: 'well',
          input: false,
          tableView: false,
          components: [
            {
              label: 'Columns',
              columns: [
                {
                  components: [
                    {
                      label: 'Customer',
                      placeholder: 'Customer',
                      hideLabel: true,
                      disabled: true,
                      tableView: true,
                      key: 'customer',
                      type: 'textfield',
                      input: true,
                      eg_gridView: true,
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'ebnjp8',
                    },
                    {
                      label: 'Customer Address',
                      placeholder: 'Customer Address',
                      hideLabel: true,
                      disabled: true,
                      tableView: true,
                      key: 'customerAddress',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'evgly4h',
                    },
                    {
                      label: 'Owner',
                      placeholder: 'Owner',
                      hideLabel: true,
                      disabled: true,
                      tableView: true,
                      key: 'owner',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'en5ppu1',
                    },
                    {
                      label: 'Customer',
                      placeholder: 'Owner Address',
                      hideLabel: true,
                      disabled: true,
                      tableView: true,
                      key: 'ownerAddress',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'ereiuh4e',
                    },
                  ],
                  width: 6,
                  offset: 0,
                  push: 0,
                  pull: 0,
                  size: 'md',
                  currentWidth: 6,
                },
                {
                  components: [
                    {
                      label: 'Date',
                      labelPosition: 'top',
                      displayInTimezone: 'viewer',
                      useLocaleSettings: false,
                      allowInput: true,
                      format: 'yyyy-MM-dd',
                      placeholder: 'Date',
                      description: '',
                      tooltip: '',
                      customClass: '',
                      tabindex: '',
                      hidden: false,
                      hideLabel: true,
                      autofocus: false,
                      disabled: false,
                      tableView: false,
                      modalEdit: false,
                      shortcutButtons: [{ label: 'Today', onClick: 'value = date.today;' }],
                      enableDate: true,
                      datePicker: { disable: '', disableFunction: '', disableWeekends: false, disableWeekdays: false, minDate: null, maxDate: null, showWeeks: true, startingDay: 0, initDate: '', minMode: 'day', maxMode: 'year', yearRows: 4, yearColumns: 5 },
                      enableTime: false,
                      timePicker: { showMeridian: true, hourStep: 1, minuteStep: 1, readonlyInput: false, mousewheel: true, arrowkeys: true },
                      multiple: false,
                      defaultValue: '',
                      defaultDate: '',
                      customOptions: {},
                      persistent: true,
                      protected: false,
                      dbIndex: false,
                      encrypted: false,
                      redrawOn: '',
                      clearOnHide: true,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      allowCalculateOverride: false,
                      validateOn: 'change',
                      validate: { required: false, customMessage: '', custom: '', customPrivate: false, json: '', strictDateValidation: false, multiple: false, unique: false },
                      enableMinDateInput: false,
                      enableMaxDateInput: false,
                      unique: false,
                      errorLabel: '',
                      errors: '',
                      key: 'date',
                      tags: [],
                      properties: {},
                      conditional: { show: null, when: null, eq: '', json: '' },
                      customConditional: '',
                      logic: [],
                      attributes: {},
                      overlay: { style: '', page: '', left: '', top: '', width: '', height: '' },
                      type: 'datetime',
                      timezone: '',
                      input: true,
                      widget: {
                        type: 'calendar',
                        displayInTimezone: 'viewer',
                        locale: 'en',
                        useLocaleSettings: false,
                        allowInput: true,
                        mode: 'single',
                        enableTime: false,
                        noCalendar: false,
                        format: 'yyyy-MM-dd',
                        hourIncrement: 1,
                        minuteIncrement: 1,
                        time_24hr: false,
                        minDate: null,
                        disabledDates: '',
                        disableWeekends: false,
                        disableWeekdays: false,
                        disableFunction: '',
                        maxDate: null,
                      },
                      prefix: '',
                      suffix: '',
                      refreshOn: '',
                      dataGridLabel: false,
                      showCharCount: false,
                      showWordCount: false,
                      allowMultipleMasks: false,
                      addons: [],
                      datepickerMode: 'day',
                      id: 'e9yuumg',
                    },
                    {
                      label: 'Work Order #',
                      placeholder: 'Work Order #',
                      hideLabel: true,
                      disabled: true,
                      tableView: true,
                      key: 'workOrder',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'effbe1j',
                    },
                    {
                      label: 'Temperature',
                      placeholder: 'Temperature',
                      suffix: '°C',
                      hideLabel: true,
                      tableView: true,
                      key: 'temperature',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'eky0a08',
                    },
                    {
                      label: 'Humidity',
                      placeholder: 'Humidity',
                      suffix: '%',
                      hideLabel: true,
                      tableView: true,
                      key: 'humidity',
                      type: 'textfield',
                      input: true,
                      eg_gridView: false,
                      prefix: '',
                      customClass: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'exj7jxm',
                    },
                  ],
                  width: 6,
                  offset: 0,
                  push: 0,
                  pull: 0,
                  size: 'md',
                  currentWidth: 6,
                },
              ],
              key: 'columns',
              type: 'columns',
              input: false,
              tableView: false,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: false,
              hidden: false,
              clearOnHide: false,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              tree: false,
              lazyLoad: false,
              autoAdjust: false,
              id: 'eobkn2q',
            },
            {
              label: 'Identification',
              tableView: true,
              case: 'uppercase',
              validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
              key: 'identification',
              type: 'textfield',
              input: true,
              eg_gridView: false,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: true,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: { type: 'input' },
              attributes: {},
              validateOn: 'change',
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              mask: false,
              inputType: 'text',
              inputFormat: 'plain',
              inputMask: '',
              displayMask: '',
              spellcheck: true,
              truncateMultipleSpaces: false,
              id: 'e0t96b',
            },
            {
              label: 'Location',
              labelPosition: 'top',
              placeholder: '',
              description: '',
              tooltip: '',
              prefix: '',
              suffix: '',
              widget: { type: 'input' },
              inputMask: '',
              displayMask: '',
              allowMultipleMasks: false,
              customClass: '',
              tabindex: '',
              autocomplete: '',
              hidden: false,
              hideLabel: false,
              showWordCount: false,
              showCharCount: false,
              mask: false,
              autofocus: false,
              spellcheck: true,
              disabled: false,
              tableView: true,
              modalEdit: false,
              multiple: false,
              persistent: true,
              inputFormat: 'plain',
              protected: false,
              dbIndex: false,
              case: 'uppercase',
              truncateMultipleSpaces: false,
              encrypted: false,
              redrawOn: '',
              clearOnHide: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              allowCalculateOverride: false,
              validateOn: 'change',
              validate: { required: false, pattern: '', customMessage: '', custom: '', customPrivate: false, json: '', minLength: '', maxLength: '', strictDateValidation: false, multiple: false, unique: false },
              unique: false,
              errorLabel: '',
              errors: '',
              key: 'parent',
              tags: [],
              properties: {},
              conditional: { show: null, when: null, eq: '', json: '' },
              customConditional: '',
              logic: [],
              attributes: {},
              overlay: { style: '', page: '', left: '', top: '', width: '', height: '' },
              type: 'textfield',
              input: true,
              eg_gridView: false,
              refreshOn: '',
              dataGridLabel: false,
              addons: [],
              inputType: 'text',
              id: 'ehvagn',
              defaultValue: '',
            },
            {
              label: 'Asset ID',
              tableView: true,
              key: 'assetId',
              type: 'textfield',
              input: true,
              eg_gridView: true,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: true,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: { type: 'input' },
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              mask: false,
              inputType: 'text',
              inputFormat: 'plain',
              inputMask: '',
              displayMask: '',
              spellcheck: true,
              truncateMultipleSpaces: false,
              id: 'eakd4u8',
            },
          ],
          placeholder: '',
          prefix: '',
          customClass: '',
          suffix: '',
          multiple: false,
          defaultValue: null,
          protected: false,
          unique: false,
          persistent: false,
          hidden: false,
          clearOnHide: true,
          refreshOn: '',
          redrawOn: '',
          modalEdit: false,
          dataGridLabel: false,
          labelPosition: 'top',
          description: '',
          errorLabel: '',
          tooltip: '',
          hideLabel: false,
          tabindex: '',
          disabled: false,
          autofocus: false,
          dbIndex: false,
          customDefaultValue: '',
          calculateValue: '',
          calculateServer: false,
          widget: null,
          attributes: {},
          validateOn: 'change',
          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
          conditional: { show: null, when: null, eq: '' },
          overlay: { style: '', left: '', top: '', width: '', height: '' },
          allowCalculateOverride: false,
          encrypted: false,
          showCharCount: false,
          showWordCount: false,
          properties: {},
          allowMultipleMasks: false,
          addons: [],
          tree: false,
          lazyLoad: false,
          id: 'eax5os',
        },
        {
          label: 'Location Fields',
          key: 'locationFields',
          type: 'well',
          input: false,
          tableView: false,
          components: [
            {
              html: '<p><strong>LOCATION FIELDS</strong></p>',
              label: 'Content',
              refreshOnChange: false,
              key: 'content',
              type: 'content',
              input: false,
              tableView: false,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: true,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              id: 'evv4pca',
            },
            {
              label: 'Columns',
              columns: [
                {
                  components: [
                    {
                      label: 'Building',
                      tableView: true,
                      key: 'building',
                      type: 'textfield',
                      input: true,
                      placeholder: '',
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      hideLabel: false,
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'elh5gyb',
                    },
                    {
                      label: 'Floor',
                      tableView: true,
                      key: 'floor',
                      type: 'textfield',
                      input: true,
                      placeholder: '',
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      hideLabel: false,
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'e19z0zc',
                    },
                  ],
                  width: 6,
                  offset: 0,
                  push: 0,
                  pull: 0,
                  size: 'md',
                  currentWidth: 6,
                },
                {
                  components: [
                    {
                      label: 'Room',
                      tableView: true,
                      key: 'room',
                      type: 'textfield',
                      input: true,
                      placeholder: '',
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      hideLabel: false,
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'edlvqd',
                    },
                    {
                      label: 'Section',
                      tableView: true,
                      key: 'section',
                      type: 'textfield',
                      input: true,
                      placeholder: '',
                      prefix: '',
                      customClass: '',
                      suffix: '',
                      multiple: false,
                      defaultValue: null,
                      protected: false,
                      unique: false,
                      persistent: true,
                      hidden: false,
                      clearOnHide: true,
                      refreshOn: '',
                      redrawOn: '',
                      modalEdit: false,
                      dataGridLabel: false,
                      labelPosition: 'top',
                      description: '',
                      errorLabel: '',
                      tooltip: '',
                      hideLabel: false,
                      tabindex: '',
                      disabled: false,
                      autofocus: false,
                      dbIndex: false,
                      customDefaultValue: '',
                      calculateValue: '',
                      calculateServer: false,
                      widget: { type: 'input' },
                      attributes: {},
                      validateOn: 'change',
                      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                      conditional: { show: null, when: null, eq: '' },
                      overlay: { style: '', left: '', top: '', width: '', height: '' },
                      allowCalculateOverride: false,
                      encrypted: false,
                      showCharCount: false,
                      showWordCount: false,
                      properties: {},
                      allowMultipleMasks: false,
                      addons: [],
                      mask: false,
                      inputType: 'text',
                      inputFormat: 'plain',
                      inputMask: '',
                      displayMask: '',
                      spellcheck: true,
                      truncateMultipleSpaces: false,
                      id: 'entyu0f',
                    },
                  ],
                  width: 6,
                  offset: 0,
                  push: 0,
                  pull: 0,
                  size: 'md',
                  currentWidth: 6,
                },
              ],
              key: 'columns1',
              type: 'columns',
              input: false,
              tableView: false,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: false,
              hidden: false,
              clearOnHide: false,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              tree: false,
              lazyLoad: false,
              autoAdjust: false,
              id: 'es2agw7',
            },
          ],
          placeholder: '',
          prefix: '',
          customClass: '',
          suffix: '',
          multiple: false,
          defaultValue: null,
          protected: false,
          unique: false,
          persistent: false,
          hidden: false,
          clearOnHide: true,
          refreshOn: '',
          redrawOn: '',
          modalEdit: false,
          dataGridLabel: false,
          labelPosition: 'top',
          description: '',
          errorLabel: '',
          tooltip: '',
          hideLabel: false,
          tabindex: '',
          disabled: false,
          autofocus: false,
          dbIndex: false,
          customDefaultValue: '',
          calculateValue: '',
          calculateServer: false,
          widget: null,
          attributes: {},
          validateOn: 'change',
          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
          conditional: { show: null, when: null, eq: '' },
          overlay: { style: '', left: '', top: '', width: '', height: '' },
          allowCalculateOverride: false,
          encrypted: false,
          showCharCount: false,
          showWordCount: false,
          properties: {},
          allowMultipleMasks: false,
          addons: [],
          tree: false,
          lazyLoad: false,
          id: 'eh70997',
        },
      ],
      placeholder: '',
      prefix: '',
      customClass: 'header-container-disable-edit',
      suffix: '',
      multiple: false,
      defaultValue: null,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      refreshOn: '',
      redrawOn: '',
      modalEdit: false,
      dataGridLabel: false,
      labelPosition: 'top',
      description: '',
      errorLabel: '',
      tooltip: '',
      hideLabel: true,
      tabindex: '',
      disabled: false,
      autofocus: false,
      dbIndex: false,
      customDefaultValue: '',
      calculateValue: '',
      calculateServer: false,
      widget: null,
      attributes: {},
      validateOn: 'change',
      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
      conditional: { show: null, when: null, eq: '' },
      overlay: { style: '', left: '', top: '', width: '', height: '' },
      allowCalculateOverride: false,
      encrypted: false,
      showCharCount: false,
      showWordCount: false,
      properties: {},
      allowMultipleMasks: false,
      addons: [],
      tree: true,
      lazyLoad: false,
      id: 'e5juh5',
    },
    {
      label: 'Footer',
      tableView: false,
      key: 'footer',
      type: 'container',
      input: true,
      components: [
        {
          title: '<b>RESULTS</b>',
          collapsible: false,
          key: 'bResultsB',
          type: 'panel',
          label: 'Panel',
          input: false,
          tableView: false,
          components: [
            {
              label: 'selection',
              calculateValue: 'value = data.selection;',
              key: 'selection1',
              type: 'hidden',
              input: true,
              tableView: false,
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: true,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateServer: false,
              widget: { type: 'input' },
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              inputType: 'hidden',
              id: 'e4iqg',
            },
            {
              label: 'verdictwell',
              key: 'verdictwell',
              type: 'well',
              input: false,
              tableView: false,
              components: [
                {
                  label: '<b>INSECTION VERDICT:</b>',
                  widget: 'choicesjs',
                  tableView: true,
                  data: {
                    values: [
                      { label: 'Pass', value: 'Pass' },
                      { label: 'Repair Needed', value: 'Repair Needed' },
                      { label: 'Replacement Needed', value: 'Replacement Needed' },
                    ],
                    json: '',
                    url: '',
                    resource: '',
                    custom: '',
                  },
                  searchEnabled: false,
                  validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                  key: 'inspectionVerdict',
                  type: 'select',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  attributes: {},
                  validateOn: 'change',
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  idPath: 'id',
                  clearOnRefresh: false,
                  limit: 100,
                  dataSrc: 'values',
                  valueProperty: '',
                  lazyLoad: true,
                  filter: '',
                  searchDebounce: 0.3,
                  searchField: '',
                  minSearch: 0,
                  readOnlyValue: false,
                  authenticate: false,
                  ignoreCache: false,
                  template: '<span>{{ item.label }}</span>',
                  selectFields: '',
                  selectThreshold: 0.3,
                  uniqueOptions: false,
                  fuseOptions: { include: 'score', threshold: 0.3 },
                  indexeddb: { filter: {} },
                  customOptions: {},
                  useExactSearch: false,
                  id: 'eqjgok',
                },
                {
                  label: 'Columns',
                  columns: [
                    {
                      components: [
                        {
                          label: '<b>REPAIR TIMING:</b>',
                          widget: 'choicesjs',
                          tableView: true,
                          defaultValue: 'today',
                          data: {
                            values: [
                              { label: 'I will repair today', value: 'today' },
                              { label: 'A future repair should be scheduled', value: 'future' },
                            ],
                            json: '',
                            url: '',
                            resource: '',
                            custom: '',
                          },
                          searchEnabled: false,
                          validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'repairSchedule',
                          conditional: { show: true, when: 'footer.inspectionVerdict', eq: 'Repair Needed' },
                          type: 'select',
                          input: true,
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          attributes: {},
                          validateOn: 'change',
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          idPath: 'id',
                          clearOnRefresh: false,
                          limit: 100,
                          dataSrc: 'values',
                          valueProperty: '',
                          lazyLoad: true,
                          filter: '',
                          searchDebounce: 0.3,
                          searchField: '',
                          minSearch: 0,
                          readOnlyValue: false,
                          authenticate: false,
                          ignoreCache: false,
                          template: '<span>{{ item.label }}</span>',
                          selectFields: '',
                          selectThreshold: 0.3,
                          uniqueOptions: false,
                          fuseOptions: { include: 'score', threshold: 0.3 },
                          indexeddb: { filter: {} },
                          customOptions: {},
                          useExactSearch: false,
                          id: 'eso1nog',
                        },
                        {
                          label: '<b>REPLACEMENT TIMING:</b>',
                          widget: 'choicesjs',
                          tableView: true,
                          defaultValue: 'today',
                          data: {
                            values: [
                              { label: 'I will replace today', value: 'today' },
                              { label: 'A future replacement should be scheduled', value: 'future' },
                            ],
                            json: '',
                            url: '',
                            resource: '',
                            custom: '',
                          },
                          searchEnabled: false,
                          validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'replacementSchedule',
                          conditional: { show: true, when: 'footer.inspectionVerdict', eq: 'Replacement Needed' },
                          type: 'select',
                          input: true,
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          attributes: {},
                          validateOn: 'change',
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          idPath: 'id',
                          clearOnRefresh: false,
                          limit: 100,
                          dataSrc: 'values',
                          valueProperty: '',
                          lazyLoad: true,
                          filter: '',
                          searchDebounce: 0.3,
                          searchField: '',
                          minSearch: 0,
                          readOnlyValue: false,
                          authenticate: false,
                          ignoreCache: false,
                          template: '<span>{{ item.label }}</span>',
                          selectFields: '',
                          selectThreshold: 0.3,
                          uniqueOptions: false,
                          fuseOptions: { include: 'score', threshold: 0.3 },
                          indexeddb: { filter: {} },
                          customOptions: {},
                          useExactSearch: false,
                          id: 'eloojnl',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                    {
                      components: [
                        {
                          label: '<b>SELECT ISSUE TYPE(S):</b>',
                          optionsLabelPosition: 'right',
                          tableView: false,
                          defaultValue: { generalMechanical: false, insulationResistance: false, contactResistance: false, trip: false, other: false, visual: false, mechanical: false, electrical: false },
                          values: [
                            { label: 'Visual Issue', value: 'visual', shortcut: '' },
                            { label: 'Mechanical Issue', value: 'mechanical', shortcut: '' },
                            { label: 'Electrical Issue', value: 'electrical', shortcut: '' },
                          ],
                          validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'selectRepairIssues',
                          conditional: { show: true, when: 'footer.inspectionVerdict', eq: 'Repair Needed' },
                          type: 'selectboxes',
                          input: true,
                          inputType: 'checkbox',
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: null,
                          attributes: {},
                          validateOn: 'change',
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          fieldSet: false,
                          inline: false,
                          id: 'ef243dn',
                        },
                        {
                          label: '<b>SELECT ISSUES:</b>',
                          optionsLabelPosition: 'right',
                          tableView: false,
                          defaultValue: { generalMechanicalIssue: false, insulationResistanceIssue: false, contactResistanceIssue: false, tripIssue: false, generalMechanical: false, insulationResistance: false, contactResistance: false, trip: false, other: false, visual: false, mechanical: false, electrical: false },
                          values: [
                            { label: 'Visual Issue', value: 'visual', shortcut: '' },
                            { label: 'Mechanical Issue', value: 'mechanical', shortcut: '' },
                            { label: 'Electrical Issue', value: 'electrical', shortcut: '' },
                          ],
                          validate: { required: true, minSelectedCount: 1, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'selectReplacementIssues',
                          conditional: { show: true, when: 'footer.inspectionVerdict', eq: 'Replacement Needed' },
                          type: 'selectboxes',
                          input: true,
                          inputType: 'checkbox',
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: null,
                          attributes: {},
                          validateOn: 'change',
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          fieldSet: false,
                          inline: false,
                          id: 'esrhiud',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                  ],
                  key: 'columns1',
                  type: 'columns',
                  input: false,
                  tableView: false,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: false,
                  hidden: false,
                  clearOnHide: false,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: null,
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  tree: false,
                  lazyLoad: false,
                  autoAdjust: false,
                  id: 'e8fktk9',
                },
                {
                  label: 'Columns',
                  columns: [
                    { components: [], width: 6, offset: 0, push: 0, pull: 0, size: 'md', currentWidth: 6 },
                    { components: [], width: 6, offset: 0, push: 0, pull: 0, size: 'md', currentWidth: 6 },
                  ],
                  key: 'columns2',
                  type: 'columns',
                  input: false,
                  tableView: false,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: false,
                  hidden: false,
                  clearOnHide: false,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: null,
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  tree: false,
                  lazyLoad: false,
                  autoAdjust: false,
                  id: 'ekorzhh',
                },
                {
                  label: 'Visual Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'visualIssueDescription',
                  conditional: { show: true, when: 'footer.selectRepairIssues', eq: 'visual' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'eppshfb',
                },
                {
                  label: 'Mechanical Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'mechanicalIssueDescription',
                  conditional: { show: true, when: 'footer.selectRepairIssues', eq: 'mechanical' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'ekpzkpe',
                },
                {
                  label: 'Electrical Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'electricalIssueDescription',
                  conditional: { show: true, when: 'footer.selectRepairIssues', eq: 'electrical' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'exkk5tk',
                },
                {
                  label: 'Visual Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'generalMechanicalIssueDescription1',
                  conditional: { show: true, when: 'footer.selectReplacementIssues', eq: 'visual' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'en0bw2',
                },
                {
                  label: 'Mechanical Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'insulationResistanceIssueDescription1',
                  conditional: { show: true, when: 'footer.selectReplacementIssues', eq: 'mechanical' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'efajbqj',
                },
                {
                  label: 'Electrical Issue Description',
                  autoExpand: false,
                  tableView: true,
                  key: 'contactResistanceIssueDescription1',
                  conditional: { show: true, when: 'footer.selectReplacementIssues', eq: 'electrical' },
                  type: 'textarea',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'esvk0c',
                },
                {
                  label: '<b>GENERAL COMMENTS</b>',
                  autoExpand: false,
                  tableView: true,
                  calculateValue:
                    "if (data.footer.inspectionVerdict === 'Pass') {\n  value = \"The Asset PASSED and is acceptable for operation.\";\n} else if (data.footer.overallVerdict === 'Alert') {\n  value = '';\n} else if (data.footer.overallVerdict === 'Danger') {\n  value = '';\n} else if (data.footer.overallVerdict === 'notSelected') {\n  value = '';\n}",
                  allowCalculateOverride: true,
                  key: 'comments',
                  type: 'textarea',
                  input: true,
                  eg_gridView: false,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'html',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  rows: 3,
                  wysiwyg: false,
                  editor: '',
                  fixedSize: true,
                  id: 'e9h0s9n',
                },
              ],
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: false,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              tree: false,
              lazyLoad: false,
              id: 'eiray2r',
            },
            {
              label: 'additionalissues',
              key: 'additionalissues',
              type: 'well',
              input: false,
              tableView: false,
              components: [
                {
                  label: 'Columns',
                  columns: [
                    {
                      components: [
                        {
                          label: '<b>ANY DEFECTS TO REPORT?</b>',
                          widget: 'choicesjs',
                          tableView: true,
                          defaultValue: 'no',
                          data: {
                            values: [
                              { label: 'No', value: 'no' },
                              { label: 'Yes', value: 'yes' },
                            ],
                            json: '',
                            url: '',
                            resource: '',
                            custom: '',
                          },
                          searchEnabled: false,
                          clearOnHide: false,
                          validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'defects',
                          type: 'select',
                          input: true,
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          attributes: {},
                          validateOn: 'change',
                          conditional: { show: null, when: null, eq: '' },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          idPath: 'id',
                          clearOnRefresh: false,
                          limit: 100,
                          dataSrc: 'values',
                          valueProperty: '',
                          lazyLoad: true,
                          filter: '',
                          searchDebounce: 0.3,
                          searchField: '',
                          minSearch: 0,
                          readOnlyValue: false,
                          authenticate: false,
                          ignoreCache: false,
                          template: '<span>{{ item.label }}</span>',
                          selectFields: '',
                          selectThreshold: 0.3,
                          uniqueOptions: false,
                          fuseOptions: { include: 'score', threshold: 0.3 },
                          indexeddb: { filter: {} },
                          customOptions: {},
                          useExactSearch: false,
                          id: 'ednulnl',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                    {
                      components: [
                        {
                          label: '<b>ADDITIONAL CODE VIOLATIONS TO REPORT?</b>',
                          widget: 'choicesjs',
                          tableView: true,
                          data: {
                            values: [
                              { label: 'No', value: 'no' },
                              { label: 'Yes', value: 'yes' },
                            ],
                            json: '',
                            url: '',
                            resource: '',
                            custom: '',
                          },
                          searchEnabled: false,
                          validate: { required: true, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                          key: 'violations',
                          type: 'select',
                          input: true,
                          defaultValue: 'no',
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          attributes: {},
                          validateOn: 'change',
                          conditional: { show: null, when: null, eq: '' },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          idPath: 'id',
                          clearOnRefresh: false,
                          limit: 100,
                          dataSrc: 'values',
                          valueProperty: '',
                          lazyLoad: true,
                          filter: '',
                          searchDebounce: 0.3,
                          searchField: '',
                          minSearch: 0,
                          readOnlyValue: false,
                          authenticate: false,
                          ignoreCache: false,
                          template: '<span>{{ item.label }}</span>',
                          selectFields: '',
                          selectThreshold: 0.3,
                          uniqueOptions: false,
                          fuseOptions: { include: 'score', threshold: 0.3 },
                          indexeddb: { filter: {} },
                          customOptions: {},
                          useExactSearch: false,
                          id: 'ekflq45',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                  ],
                  key: 'columns3',
                  type: 'columns',
                  input: false,
                  tableView: false,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: false,
                  hidden: false,
                  clearOnHide: false,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: null,
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  tree: false,
                  lazyLoad: false,
                  autoAdjust: false,
                  id: 'erg4owd',
                },
                {
                  label: 'Columns',
                  columns: [
                    {
                      components: [
                        {
                          label: 'Defect Description',
                          autoExpand: false,
                          tableView: true,
                          key: 'defectDescription',
                          conditional: { show: true, when: 'footer.defects', eq: 'yes' },
                          type: 'textarea',
                          input: true,
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          defaultValue: null,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: { type: 'input' },
                          attributes: {},
                          validateOn: 'change',
                          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '', minWords: '', maxWords: '' },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          mask: false,
                          inputType: 'text',
                          inputFormat: 'html',
                          inputMask: '',
                          displayMask: '',
                          spellcheck: true,
                          truncateMultipleSpaces: false,
                          rows: 3,
                          wysiwyg: false,
                          editor: '',
                          fixedSize: true,
                          id: 'e116z7d',
                        },
                        {
                          label: 'Upload Photos',
                          tableView: false,
                          image: true,
                          uploadOnly: true,
                          webcam: true,
                          fileTypes: [{ label: '', value: '' }],
                          key: 'defectPhotos',
                          conditional: { show: true, when: 'footer.defects', eq: 'yes' },
                          type: 'file',
                          input: true,
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          defaultValue: null,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          hideLabel: false,
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: null,
                          attributes: {},
                          validateOn: 'change',
                          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          privateDownload: false,
                          imageSize: '200',
                          filePattern: '*',
                          fileMinSize: '0KB',
                          fileMaxSize: '1GB',
                          id: 'edvwxt',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                    {
                      components: [
                        {
                          label: 'Data Grid',
                          reorder: false,
                          addAnotherPosition: 'bottom',
                          layoutFixed: false,
                          enableRowGroups: false,
                          initEmpty: true,
                          hideLabel: true,
                          tableView: false,
                          defaultValue: [{ selectViolation: '' }],
                          key: 'necViolations',
                          conditional: { show: true, when: 'footer.violations', eq: 'yes' },
                          type: 'datagrid',
                          input: true,
                          components: [
                            {
                              label: 'NEC Violation(s)',
                              widget: 'choicesjs',
                              tableView: true,
                              data: {
                                values: [
                                  { label: 'Circuit - Breaker is restricted from freely operating', value: 'Circuit - Breaker is restricted from freely operating' },
                                  { label: 'Circuit - Exceeds panel limit', value: 'Circuit - Exceeds panel limit' },
                                  { label: 'Component - Visible Corrosion', value: 'Component - Visible Corrosion' },
                                  { label: 'Conduit - Improperly fastened or secured', value: 'Conduit - Improperly fastened or secured' },
                                  { label: 'Enclosure - Missing dead front, door, cover, etc.', value: 'Enclosure - Missing dead front, door, cover, etc.' },
                                  { label: 'Enclosure - Must be free of foreign materials', value: 'Enclosure - Must be free of foreign materials' },
                                  { label: 'Enclosure - Unused opening must be sealed', value: 'Enclosure - Unused opening must be sealed' },
                                  { label: 'Fuse - Parallel fuses must match', value: 'Fuse - Parallel fuses must match' },
                                  { label: 'General - Lack of component integrity', value: 'General - Lack of component integrity' },
                                  { label: 'General - Not installed in a proper worklike manner', value: 'General - Not installed in a proper worklike manner' },
                                  { label: 'Grounding - Need earth connection', value: 'Grounding - Need earth connection' },
                                  { label: 'Marking/Labels - Missing or Insufficient information', value: 'Marking/Labels - Missing or Insufficient information' },
                                  { label: 'Mechanics - Damaged/broken parts', value: 'Mechanics - Damaged/broken parts' },
                                  { label: 'Missing arc flash and shock hazard warning labels', value: 'Missing arc flash and shock hazard warning labels' },
                                  { label: 'Plug Fuse - Exposed energized parts', value: 'Plug Fuse - Exposed energized parts' },
                                  { label: 'Temperaature - Inadequate ventilation/cooling for component', value: 'Temperaature - Inadequate ventilation/cooling for component' },
                                  { label: 'Terminals - Connection made without damaging wire', value: 'Terminals - Connection made without damaging wire' },
                                  { label: 'Wire - 1 wire per terminal', value: 'Wire - 1 wire per terminal' },
                                  { label: 'Wire - Improper Neutral Conductor', value: 'Wire - Improper Neutral Conductor' },
                                  { label: 'Wire - Not Protected from damage', value: 'Wire - Not Protected from damage' },
                                  { label: 'Wire - Size wrong for load', value: 'Wire - Size wrong for load' },
                                  { label: 'Wire - Wire bundle should have listed bushing', value: 'Wire - Wire bundle should have listed bushing' },
                                  { label: 'Wire - Wire burned or damaged', value: 'Wire - Wire burned or damaged' },
                                ],
                                json: '',
                                url: '',
                                resource: '',
                                custom: '',
                              },
                              key: 'selectViolation',
                              type: 'select',
                              input: true,
                              id: 'ey607l8',
                              placeholder: '',
                              prefix: '',
                              customClass: '',
                              suffix: '',
                              multiple: false,
                              defaultValue: null,
                              protected: false,
                              unique: false,
                              persistent: true,
                              hidden: false,
                              clearOnHide: true,
                              refreshOn: '',
                              redrawOn: '',
                              modalEdit: false,
                              dataGridLabel: false,
                              labelPosition: 'top',
                              description: '',
                              errorLabel: '',
                              tooltip: '',
                              hideLabel: false,
                              tabindex: '',
                              disabled: false,
                              autofocus: false,
                              dbIndex: false,
                              customDefaultValue: '',
                              calculateValue: '',
                              calculateServer: false,
                              attributes: {},
                              validateOn: 'change',
                              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                              conditional: { show: null, when: null, eq: '' },
                              overlay: { style: '', left: '', top: '', width: '', height: '' },
                              allowCalculateOverride: false,
                              encrypted: false,
                              showCharCount: false,
                              showWordCount: false,
                              properties: {},
                              allowMultipleMasks: false,
                              addons: [],
                              idPath: 'id',
                              clearOnRefresh: false,
                              limit: 100,
                              dataSrc: 'values',
                              valueProperty: '',
                              lazyLoad: true,
                              filter: '',
                              searchEnabled: true,
                              searchDebounce: 0.3,
                              searchField: '',
                              minSearch: 0,
                              readOnlyValue: false,
                              authenticate: false,
                              ignoreCache: false,
                              template: '<span>{{ item.label }}</span>',
                              selectFields: '',
                              selectThreshold: 0.3,
                              uniqueOptions: false,
                              fuseOptions: { include: 'score', threshold: 0.3 },
                              indexeddb: { filter: {} },
                              customOptions: {},
                              useExactSearch: false,
                            },
                          ],
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: null,
                          attributes: {},
                          validateOn: 'change',
                          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          tree: true,
                          lazyLoad: false,
                          disableAddingRemovingRows: false,
                          id: 'e1l684',
                        },
                        {
                          label: 'Data Grid',
                          reorder: false,
                          addAnotherPosition: 'bottom',
                          layoutFixed: false,
                          enableRowGroups: false,
                          initEmpty: true,
                          hideLabel: true,
                          tableView: false,
                          defaultValue: [{ selectViolation: '' }],
                          key: 'oshaViolations',
                          conditional: { show: true, when: 'footer.violations', eq: 'yes' },
                          type: 'datagrid',
                          input: true,
                          components: [
                            {
                              label: 'OSHA Violation(s)',
                              widget: 'choicesjs',
                              tableView: true,
                              data: {
                                values: [
                                  { label: 'Clearance - Insufficient Access', value: 'Clearance - Insufficient Access' },
                                  { label: 'Enclosure - Broken locking mechanism', value: 'Enclosure - Broken locking mechanism' },
                                  { label: 'Enclosure - Damaged', value: 'Enclosure - Damaged' },
                                  { label: 'Enclosure - Should be waterproof', value: 'Enclosure - Should be waterproof' },
                                  { label: 'Equipment - Free of Hazards', value: 'Equipment - Free of Hazards' },
                                  { label: 'Grounding - Must be permanent & continuous', value: 'Grounding - Must be permanent & continuous' },
                                  { label: 'Lighting - Inadequate around equipment', value: 'Lighting - Inadequate around equipment' },
                                  { label: 'Marking/Labels - Inadequate or missing information on equipment', value: 'Marking/Labels - Inadequate or missing information on equipment' },
                                  { label: 'Mounting - Should be secure', value: 'Mounting - Should be secure' },
                                  { label: 'Noise - Excessive', value: 'Noise - Excessive' },
                                  { label: 'Wire - Exposed', value: 'Wire - Exposed' },
                                ],
                                json: '',
                                url: '',
                                resource: '',
                                custom: '',
                              },
                              key: 'selectViolation',
                              type: 'select',
                              input: true,
                              id: 'e8uo9wp',
                              placeholder: '',
                              prefix: '',
                              customClass: '',
                              suffix: '',
                              multiple: false,
                              defaultValue: null,
                              protected: false,
                              unique: false,
                              persistent: true,
                              hidden: false,
                              clearOnHide: true,
                              refreshOn: '',
                              redrawOn: '',
                              modalEdit: false,
                              dataGridLabel: false,
                              labelPosition: 'top',
                              description: '',
                              errorLabel: '',
                              tooltip: '',
                              hideLabel: false,
                              tabindex: '',
                              disabled: false,
                              autofocus: false,
                              dbIndex: false,
                              customDefaultValue: '',
                              calculateValue: '',
                              calculateServer: false,
                              attributes: {},
                              validateOn: 'change',
                              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, onlyAvailableItems: false },
                              conditional: { show: null, when: null, eq: '' },
                              overlay: { style: '', left: '', top: '', width: '', height: '' },
                              allowCalculateOverride: false,
                              encrypted: false,
                              showCharCount: false,
                              showWordCount: false,
                              properties: {},
                              allowMultipleMasks: false,
                              addons: [],
                              idPath: 'id',
                              clearOnRefresh: false,
                              limit: 100,
                              dataSrc: 'values',
                              valueProperty: '',
                              lazyLoad: true,
                              filter: '',
                              searchEnabled: true,
                              searchDebounce: 0.3,
                              searchField: '',
                              minSearch: 0,
                              readOnlyValue: false,
                              authenticate: false,
                              ignoreCache: false,
                              template: '<span>{{ item.label }}</span>',
                              selectFields: '',
                              selectThreshold: 0.3,
                              uniqueOptions: false,
                              fuseOptions: { include: 'score', threshold: 0.3 },
                              indexeddb: { filter: {} },
                              customOptions: {},
                              useExactSearch: false,
                            },
                          ],
                          placeholder: '',
                          prefix: '',
                          customClass: '',
                          suffix: '',
                          multiple: false,
                          protected: false,
                          unique: false,
                          persistent: true,
                          hidden: false,
                          clearOnHide: true,
                          refreshOn: '',
                          redrawOn: '',
                          modalEdit: false,
                          dataGridLabel: false,
                          labelPosition: 'top',
                          description: '',
                          errorLabel: '',
                          tooltip: '',
                          tabindex: '',
                          disabled: false,
                          autofocus: false,
                          dbIndex: false,
                          customDefaultValue: '',
                          calculateValue: '',
                          calculateServer: false,
                          widget: null,
                          attributes: {},
                          validateOn: 'change',
                          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                          overlay: { style: '', left: '', top: '', width: '', height: '' },
                          allowCalculateOverride: false,
                          encrypted: false,
                          showCharCount: false,
                          showWordCount: false,
                          properties: {},
                          allowMultipleMasks: false,
                          addons: [],
                          tree: true,
                          lazyLoad: false,
                          disableAddingRemovingRows: false,
                          id: 'esq7sfs',
                        },
                      ],
                      width: 6,
                      offset: 0,
                      push: 0,
                      pull: 0,
                      size: 'md',
                      currentWidth: 6,
                    },
                  ],
                  key: 'columns4',
                  type: 'columns',
                  input: false,
                  tableView: false,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: false,
                  hidden: false,
                  clearOnHide: false,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: null,
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  tree: false,
                  lazyLoad: false,
                  autoAdjust: false,
                  id: 'eyh78bh',
                },
              ],
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: false,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              tree: false,
              lazyLoad: false,
              id: 'ev3nwx',
            },
            {
              label: 'finalFooter',
              key: 'finalFooter',
              type: 'well',
              input: false,
              tableView: false,
              components: [
                {
                  label: 'Test Equipment Number',
                  tableView: true,
                  key: 'testEquipmentNumber',
                  type: 'textfield',
                  input: true,
                  eg_gridView: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'plain',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  id: 'eblg0m',
                },
                {
                  label: 'Tested By:',
                  tableView: true,
                  key: 'testedBy',
                  type: 'textfield',
                  input: true,
                  placeholder: '',
                  prefix: '',
                  customClass: '',
                  suffix: '',
                  multiple: false,
                  defaultValue: null,
                  protected: false,
                  unique: false,
                  persistent: true,
                  hidden: false,
                  clearOnHide: true,
                  refreshOn: '',
                  redrawOn: '',
                  modalEdit: false,
                  dataGridLabel: false,
                  labelPosition: 'top',
                  description: '',
                  errorLabel: '',
                  tooltip: '',
                  hideLabel: false,
                  tabindex: '',
                  disabled: false,
                  autofocus: false,
                  dbIndex: false,
                  customDefaultValue: '',
                  calculateValue: '',
                  calculateServer: false,
                  widget: { type: 'input' },
                  attributes: {},
                  validateOn: 'change',
                  validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false, minLength: '', maxLength: '', pattern: '' },
                  conditional: { show: null, when: null, eq: '' },
                  overlay: { style: '', left: '', top: '', width: '', height: '' },
                  allowCalculateOverride: false,
                  encrypted: false,
                  showCharCount: false,
                  showWordCount: false,
                  properties: {},
                  allowMultipleMasks: false,
                  addons: [],
                  mask: false,
                  inputType: 'text',
                  inputFormat: 'plain',
                  inputMask: '',
                  displayMask: '',
                  spellcheck: true,
                  truncateMultipleSpaces: false,
                  id: 'eno0pwi',
                },
                {
                  label: 'Test Equipment Calibration Table',
                  reorder: false,
                  addAnotherPosition: 'bottom',
                  layoutFixed: false,
                  enableRowGroups: false,
                  initEmpty: false,
                  tableView: false,
                  defaultValue: [
                    {
                      equipmentId: '',
                      name: '',
                      serialNumber: '',
                      calibrationDate: '',
                    },
                  ],
                  key: 'testEquipmentCalibrationTable',
                  attributes: {
                    'Equipment ID': 'equipmentId',
                  },
                  type: 'datagrid',
                  input: true,
                  components: [
                    {
                      label: 'Equipment ID',
                      tableView: true,
                      key: 'equipmentId',
                      type: 'textfield',
                      input: true,
                    },
                    {
                      label: 'Name',
                      tableView: true,
                      key: 'name',
                      type: 'textfield',
                      input: true,
                    },
                    {
                      label: 'Serial Number',
                      tableView: true,
                      key: 'serialNumber',
                      type: 'textfield',
                      input: true,
                    },
                    {
                      label: 'Calibration Date',
                      displayInTimezone: 'submission',
                      format: 'yyyy-MM-dd',
                      placeholder: 'Date',
                      tableView: false,
                      shortcutButtons: [
                        {
                          label: 'Today',
                          onClick: 'value = date.today;',
                        },
                      ],
                      datePicker: {
                        disableWeekends: false,
                        disableWeekdays: false,
                      },
                      enableTime: false,
                      enableMinDateInput: false,
                      enableMaxDateInput: false,
                      key: 'calibrationDate',
                      type: 'datetime',
                      input: true,
                      widget: {
                        type: 'calendar',
                        displayInTimezone: 'submission',
                        locale: 'en',
                        useLocaleSettings: false,
                        allowInput: true,
                        mode: 'single',
                        enableTime: false,
                        noCalendar: false,
                        format: 'yyyy-MM-dd',
                        hourIncrement: 1,
                        minuteIncrement: 1,
                        time_24hr: false,
                        minDate: null,
                        disableWeekends: false,
                        disableWeekdays: false,
                        maxDate: null,
                      },
                    },
                  ],
                },
              ],
              placeholder: '',
              prefix: '',
              customClass: '',
              suffix: '',
              multiple: false,
              defaultValue: null,
              protected: false,
              unique: false,
              persistent: false,
              hidden: false,
              clearOnHide: true,
              refreshOn: '',
              redrawOn: '',
              modalEdit: false,
              dataGridLabel: false,
              labelPosition: 'top',
              description: '',
              errorLabel: '',
              tooltip: '',
              hideLabel: false,
              tabindex: '',
              disabled: false,
              autofocus: false,
              dbIndex: false,
              customDefaultValue: '',
              calculateValue: '',
              calculateServer: false,
              widget: null,
              attributes: {},
              validateOn: 'change',
              validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
              conditional: { show: null, when: null, eq: '' },
              overlay: { style: '', left: '', top: '', width: '', height: '' },
              allowCalculateOverride: false,
              encrypted: false,
              showCharCount: false,
              showWordCount: false,
              properties: {},
              allowMultipleMasks: false,
              addons: [],
              tree: false,
              lazyLoad: false,
              id: 'epkqym',
            },
          ],
          placeholder: '',
          prefix: '',
          customClass: '',
          suffix: '',
          multiple: false,
          defaultValue: null,
          protected: false,
          unique: false,
          persistent: false,
          hidden: false,
          clearOnHide: false,
          refreshOn: '',
          redrawOn: '',
          modalEdit: false,
          dataGridLabel: false,
          labelPosition: 'top',
          description: '',
          errorLabel: '',
          tooltip: '',
          hideLabel: false,
          tabindex: '',
          disabled: false,
          autofocus: false,
          dbIndex: false,
          customDefaultValue: '',
          calculateValue: '',
          calculateServer: false,
          widget: null,
          attributes: {},
          validateOn: 'change',
          validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
          conditional: { show: null, when: null, eq: '' },
          overlay: { style: '', left: '', top: '', width: '', height: '' },
          allowCalculateOverride: false,
          encrypted: false,
          showCharCount: false,
          showWordCount: false,
          properties: {},
          allowMultipleMasks: false,
          addons: [],
          tree: false,
          lazyLoad: false,
          theme: 'default',
          breadcrumb: 'default',
          id: 'egmxcp',
        },
      ],
      placeholder: '',
      prefix: '',
      customClass: '',
      suffix: '',
      multiple: false,
      defaultValue: null,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      refreshOn: '',
      redrawOn: '',
      modalEdit: false,
      dataGridLabel: false,
      labelPosition: 'top',
      description: '',
      errorLabel: '',
      tooltip: '',
      hideLabel: true,
      tabindex: '',
      disabled: false,
      autofocus: false,
      dbIndex: false,
      customDefaultValue: '',
      calculateValue: '',
      calculateServer: false,
      widget: null,
      attributes: {},
      validateOn: 'change',
      validate: { required: false, custom: '', customPrivate: false, strictDateValidation: false, multiple: false, unique: false },
      conditional: { show: null, when: null, eq: '' },
      overlay: { style: '', left: '', top: '', width: '', height: '' },
      allowCalculateOverride: false,
      encrypted: false,
      showCharCount: false,
      showWordCount: false,
      properties: {},
      allowMultipleMasks: false,
      addons: [],
      tree: true,
      lazyLoad: false,
      id: 'e10k39q',
    },
  ],
}

export default newFormData
